import styled from 'styled-components';
import { device, colors } from '../../styles/stylesheets';
import arrowLeft from '../../assets/icons/general/arrowLeft.svg';

export const Button = styled.button`
  background-color: ${({ bgColor }) => (bgColor || colors.primary)};
  border-radius: 4px;
  color: ${({ color }) => (color || colors.white)};
  border: ${({ border }) => (border || 'none')};
  font: inherit;
  cursor: pointer;
  outline: inherit;
  padding: 8px 12px;

  &:hover {
    opacity: 0.8;
  }
`;

export const ButtonModal = styled(Button)`
  width: 80%;
  padding: 20px;
  
  margin: 12px;
  font-weight: 500;
`;

export const ButtonBack = styled(Button)`
  position: absolute;
  visibility: ${({ none }) => (none ? 'hidden' : '')};
  width: 94px;
  height: 44px;
  border: 1px solid ${colors.greyLight};

  font-size: 15px;
  line-height: 20px;
  background: url(${arrowLeft}) no-repeat 10px center;
  background-color: ${colors.white};
  color: inherit;

  span {
    margin-left: 12px;

    @media ${device.untilTablet} {
      display: none;
    }
  }

  @media ${device.untilTablet} {
    width: 30px;
    height: 30px;
  }
  &:hover {
    background-color: #e2e2e2;
  }
`;
